import { defineMessages } from '@/i18n'

export const messages = defineMessages({
  ru: {
    // WaitingPayment
    waiting: 'Ждём подтверждения оплаты…',
    paymentCanceled: 'Платёж отменён',
    paymentFailed: 'Платёж не прошёл',
    paymentRefunded: 'Платёж возвращён',
    paymentDegraded: 'Оплата открыта в соседней вкладке. Когда закончите — обновите баланс',
    paymentExpired: 'Мы больше не ждём ответа об оплате. Если платёж прошёл — обновите баланс',
    reopenPayment: 'Открыть окно оплаты снова',
    refreshBalance: 'Обновить баланс',
    otherMethod: 'Выбрать другой способ',
    chooseAnother: 'Выбрать другой пакет или способ',
    cryptoAbandonNote:
      'Если вы уже отправили криптовалюту, не уходите: платёж дойдёт и кредиты начислятся',
    toPackages: 'К пакетам',
    // HistoryDetailDialog
    fieldRun: 'Запуск',
    fieldPrompt: 'Промпт',
    fieldModel: 'Модель',
    fieldWhen: 'Когда',
    fieldAmount: 'Сумма',
    colRun: 'Генерация',
    colTime: 'Время',
    colSpent: 'Расход',
    fieldBalanceAfter: 'Баланс после операции',
    // MethodPicker
    noEmail: 'Оплата российской картой требует email в профиле',
    rubUnavailable: 'Рублёвая оплата сейчас недоступна',
    nothingToPayWith: (cause: string) => `${cause} — оплатить этот пакет нечем`,
    packageNotPayable: 'Этот пакет сейчас нельзя оплатить',
    back: 'Назад',
    pay: 'Оплатить',
    payPrice: (price: string) => `Оплатить ${price}`,
    // HistoryList
    historyFailed: 'История не загрузилась.',
    retry: 'Повторить',
    emptyPage: 'На этой странице движений нет.',
    toHistoryStart: 'К началу истории',
    emptyTitle: 'Пока что тут пусто…',
    emptyDescription: 'Вы ещё не использовали кредиты для создания курсов',
    // CreditsOverview
    held: (amount: string) =>
      `Заморожено ${amount} под идущим запуском — эти кредиты вернутся, если запуск не потратит их целиком`,
    topUp: 'Пополнить',
    tabUsage: 'Расход',
    tabPayments: 'Платежи',
    // TopUpDialog
    creditsTitle: 'Кредиты',
    buyCreditsTitle: 'Купить кредиты',
    creditsDescription: 'Баланс, расход и платежи',
    // PaymentDone / usePaymentWatcher
    balanceToppedUpExcl: 'Баланс пополнен!',
    balanceNow: (amount: string) => `Баланс: ${amount}`,
    balanceToppedUp: 'Баланс пополнен',
    backToWork: 'Вернуться к работе',
    // ContactEmailForm
    emailInvalid: 'Введите корректный email',
    emailFailed: 'Не удалось сохранить email. Попробуйте ещё раз',
    emailLabel: 'Email для оплаты российской картой',
    save: 'Сохранить',
    // PackagesGrid / PackageCard
    packagesFailed: 'Не удалось загрузить пакеты пополнения',
    packagesUnavailable: 'Пакеты пополнения сейчас недоступны',
    fitsRun: 'Хватит на этот запуск',
    packagePaymentUnavailable: 'Оплата этого пакета сейчас недоступна',
    choose: 'Выбрать',
    // HistoryRow / HistoryPager / MethodTiles / TopUpSubtitle / HistoryThumb
    details: (label: string) => `Подробности: ${label}`,
    prevPage: 'Предыдущая страница',
    nextPage: 'Следующая страница',
    paymentMethod: 'Способ оплаты',
    runNeeds: (amount: string) => `Для этого запуска нужно ${amount}`,
    choosePackage: 'Выберите пакет кредитов',
    imageGone: 'Картинка больше недоступна — файл удалён из хранилища',
    // RegionLine
    region: 'Регион',
    regionNotSelected: 'Регион не выбран',
    regionChange: 'изменить',
    regionPick: 'выбрать',
  },
  en: {
    waiting: 'Waiting for payment confirmation…',
    paymentCanceled: 'Payment cancelled',
    paymentFailed: 'Payment failed',
    paymentRefunded: 'Payment refunded',
    paymentDegraded:
      'The payment page is open in another tab. When you’re done, refresh your balance',
    paymentExpired:
      'We’ve stopped checking the payment status. If the payment went through, refresh your balance',
    reopenPayment: 'Reopen payment page',
    refreshBalance: 'Refresh balance',
    otherMethod: 'Choose another method',
    chooseAnother: 'Choose another package or method',
    cryptoAbandonNote:
      "If you've already sent the crypto, stay here: the payment will arrive and the credits will be added",
    toPackages: 'Back to packages',
    fieldRun: 'Run',
    fieldPrompt: 'Prompt',
    fieldModel: 'Model',
    fieldWhen: 'When',
    fieldAmount: 'Amount',
    colRun: 'Generation',
    colTime: 'Time',
    colSpent: 'Spent',
    fieldBalanceAfter: 'Balance after',
    noEmail: 'Paying with a Russian card requires an email in your profile',
    rubUnavailable: 'Payment in rubles is currently unavailable',
    nothingToPayWith: (cause: string) =>
      `${cause} — no payment method is available for this package`,
    packageNotPayable: 'This package can’t be paid for right now',
    back: 'Back',
    pay: 'Pay',
    payPrice: (price: string) => `Pay ${price}`,
    historyFailed: 'Couldn’t load the history.',
    retry: 'Retry',
    emptyPage: 'No transactions on this page.',
    toHistoryStart: 'Go to first page',
    emptyTitle: 'Nothing here yet…',
    emptyDescription: 'You haven’t used credits to create courses yet',
    held: (amount: string) =>
      `${amount} held for a run in progress — these credits come back if the run doesn’t use them all`,
    topUp: 'Top up',
    tabUsage: 'Usage',
    tabPayments: 'Payments',
    creditsTitle: 'Credits',
    buyCreditsTitle: 'Buy credits',
    creditsDescription: 'Balance, usage and payments',
    balanceToppedUpExcl: 'Balance topped up!',
    balanceNow: (amount: string) => `Balance: ${amount}`,
    balanceToppedUp: 'Balance topped up',
    backToWork: 'Back to work',
    emailInvalid: 'Enter a valid email',
    emailFailed: 'Couldn’t save the email. Try again',
    emailLabel: 'Email for paying with a Russian card',
    save: 'Save',
    packagesFailed: 'Couldn’t load credit packages',
    packagesUnavailable: 'Credit packages are currently unavailable',
    fitsRun: 'Enough for this run',
    packagePaymentUnavailable: 'Payment for this package is currently unavailable',
    choose: 'Choose',
    details: (label: string) => `Details: ${label}`,
    prevPage: 'Previous page',
    nextPage: 'Next page',
    paymentMethod: 'Payment method',
    runNeeds: (amount: string) => `This run needs ${amount}`,
    choosePackage: 'Choose a credit package',
    imageGone: 'Image no longer available — the file was removed from storage',
    region: 'Region',
    regionNotSelected: 'Region not selected',
    regionChange: 'change',
    regionPick: 'choose',
  },
})
